import { immer } from "zustand/middleware/immer";
import { create } from "zustand";
import { createSelectors } from "@/lib/storeUtils";
import { createJSONStorage, persist } from "zustand/middleware";

type MobileDeviceModalStoreState = {
    isOpen: boolean;
    isDismissed: boolean;
    setOpen: (value: boolean) => void;
    close: () => void;
};

const baseStore = immer<MobileDeviceModalStoreState>((set) => {
    return {
        isOpen: false,
        isDismissed: false,
        setOpen: (value: boolean) =>
            set((state) => {
                if (!state.isDismissed) {
                    state.isOpen = value;
                }
            }),
        close: () =>
            set((state) => {
                state.isOpen = false;
                state.isDismissed = true;
            }),
    };
});

export const mobileDeviceModalStore = create(
    persist(baseStore, {
        name: "mobileDeviceModalStore",
        storage: createJSONStorage(() => sessionStorage),
    })
);
export const useMobileDeviceModalStore = createSelectors(mobileDeviceModalStore);
